import SidePanelHeader from "../components/SidePanelHeader"
import { useNavigate } from "react-router"
import * as Navigation from "../../../../../modules/Navigation";
import SidePanelInfo from "../components/SidePanelInfo"
import { EntityNames } from "../../../../../enums/EntityNames";
import { Button } from "react-aria-components";
import { useEffect, useState } from "react";
import { PermissionContextType, usePermissions } from "../../../../../modules/auth/Permissions/PermissionContext";
import { hasPermission } from "../../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../../modules/auth/Permissions/PermissionStrings";
import { DisposalStatusSmartEnum } from "../../../../../enums/Domain/DisposalStatusSmartEnum";
import SidePanelDisposalYears from "../components/SidePanelDisposalYears";
import { httpGet } from "../../../../../modules/Backend";
import { StatusDto } from "../../../../../enums/Domain/Status";
import SidePanelList from "../components/SidePanelList";
import { IDisposalCheck } from "./SidePanelDisposalPickList";

export default function SidePanelDisposalsView({ data, onViewPage }: any) {
    const navigate = useNavigate();
    const permissionsContext = usePermissions();
    const [status, setStatus] = useState<StatusDto | undefined>(data?.status);

    function viewEntity() {
        Navigation.view.navigate(navigate, EntityNames.disposals, data.id, data)
    }

    async function refreshDisposalStatus() {
        const result = await httpGet(`api/${EntityNames.disposals}/get?id=${data.id}`);
        if (result.data) {
            const newStatus = result.data.status;
            setStatus(newStatus);
        }
    }

    useEffect(() => {
        if (data && onViewPage) {
            const interval = setInterval(refreshDisposalStatus, 5000);
            return () => clearInterval(interval);
        } else if (data) {
            setStatus(data.status)
        }
    }, [data, onViewPage])

    return (<>
        {data &&
            <>
                {<SidePanelHeader descriptor="Disposal" value={`${data.reference}`} statuses={status} onClick={!onViewPage ? () => viewEntity() : undefined} />}
                <Actions data={data} status={status} permissionsContext={permissionsContext} onViewPage={onViewPage} />
                <SidePanelInfo
                    values={[
                        { label: "Reference", value: data.reference },
                        { label: "Account", value: data.accountName },
                    ]}
                />
                <SidePanelInfo
                    values={[
                        { label: "Requested by", value: data.requestedBy },
                        { label: "Requested at", value: data.requestedAt },
                    ]}
                />
                <SidePanelInfo
                    values={[
                        { label: "Dispose material from year", value: data.disposeMaterialOlderThanYears? undefined : data.disposeMaterialFromYear },
                        { label: "Dispose material older than", value: data.disposeMaterialOlderThanYears ? `${data.disposeMaterialOlderThanYears} years` : undefined },
                        { label: "Material types to dispose", value: data.materialTypeName },
                    ]}
                />
                <SidePanelInfo
                    values={[
                        { label: "Cancellation Notes", value: data.cancellationNotes },
                    ]}
                />
                <SidePanelDisposalYears disposalId={data.id} />

                {status && status.value === DisposalStatusSmartEnum.Complete.value &&
                    <SidePanelList<IDisposalCheck>
                        id={data?.id}
                        entityName={EntityNames.disposalChecks}
                        displayName="Disposal checked by"
                        loadingRowCount={1}
                        fixedHeight={210}
                        isSmall={true}
                        renderRowContent={(item, edit, remove) => (
                            <>
                                <td>
                                    <div className="display--flex justifyContent--space-between padding--xxs alignItems--center">
                                        <div className="side-panel-table__cell-content">
                                            <p className="small small--2 textWrap">{item.operatorName}</p>
                                        </div>
                                    </div>
                                </td>
                            </>
                        )}
                        displayColumns={
                            <>
                                <th><p className="small"></p></th>
                            </>
                        }
                    />
                }
            </>
        }
    </>)
}

function Actions({ data, status, permissionsContext, onViewPage }: { data: any, status: StatusDto | undefined, permissionsContext: PermissionContextType, onViewPage: boolean }) {
    return (
        <div className="display--flex gap--s flex__wrap--wrap margin__top--s">
            {hasPermission(permissionsContext.permissions!, PermissionTypes.read, PermissionConcerns.CellNass_Operators) && status?.value === DisposalStatusSmartEnum.ToPick.value && <PickButton id={data.id} />}
        </div>
    )
}

function PickButton({ id }: { id: string }) {
    const navigate = useNavigate()

    return (
        <Button className={"button button--small button--primary button--with-icon"} onPress={() => { Navigation.DisposalsPicking.navigate(navigate, id) }}>
            <p className="button-text">Start Picking</p>
        </Button>
    )
}